import * as S from './index.style'

export type MensagemErro = {
  titulo: string
  mensagens: string[]
}

const MensagensErro: React.FC<{ erros: MensagemErro[] }> = ({ erros }) => {
  return (
    <>
      {erros.length >= 1 && (
        <S.Wrapper data-cy="mensagensErro">
          <S.Icone />
          <S.Title>{`${erros.length} ${erros.length == 1 ? 'Erro Encontrado' : 'Erros Encontrados'}`}</S.Title>
          <br />
          {erros.map((erro, indexErro) => (
            <div key={indexErro}>
              <S.SubTitle>{erro.titulo}</S.SubTitle>
              <S.Lista>
                {erro.mensagens.map((mensagem, indexMsg) => (
                  <span key={indexMsg}>{`${++indexErro}. ${mensagem}`}</span>
                ))}
              </S.Lista>
            </div>
          ))}
        </S.Wrapper>
      )}
    </>
  )
}

export default MensagensErro
